import script from "./InvoiceTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTableRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTableRow.vue?vue&type=style&index=0&id=6884edb5&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6884edb5"]])

export default __exports__